module.exports = __webpack_public_path__ + "images/icons/icon-juul-logo-6ae03af9.svg";